class LoginPageController {

  constructor(AuthorisationService) {
    this.AuthorisationService = AuthorisationService;
  }

  $onInit() {
    this.credentials = {
      username: null,
      password: null
    };
    this.validationError = null;
    this.loading = false;
  }

  login() {
    var self = this;
    self.loading = true;
    self.AuthorisationService.login(self.credentials)
        .catch(function(){
          self.validationError = "There was a problem logging you in";
        })
        .finally(function(){
          self.loading = false;
        });
  }
}
LoginPageController.$inject = ['AuthorisationService'];
export default LoginPageController;
